import map from 'lodash/map';

import jStat from 'jstat';

import React from 'react';
import PropTypes from 'prop-types';
import { change } from 'redux-form';
import { connect } from 'react-redux';
import { round4 as round } from 'utilities/math';

import TailTypeRadioButtonComponent from './Component';

class TailTypeRadioButtonContainer extends React.PureComponent {
  static propTypes = {
    handleChange: PropTypes.func.isRequired
  }

  constructor (props) {
    super(props);

    this.handleChange = (_, newTailType) =>
      this.props.handleChange(this.props, newTailType);
  }

  render () {
    return <TailTypeRadioButtonComponent {...this.props} onChange={this.handleChange} />;
  }
}

const mapDispatchToProps = {
  handleChange: (props, newTailType) => (dispatch, getState) => {
    const state = getState();

    const alpha = newTailType === 'both'
      ? props.getAlpha(state) / 2
      : props.getAlpha(state);

    const { form, mean, stdev } = props;

    const cutoffs = {
      leftCutoff: round(jStat.normal.inv(alpha, mean, stdev)),
      rightCutoff: round(jStat.normal.inv(1 - alpha, mean, stdev))
    };

    dispatch(
      map(cutoffs, (cutoffValue, cutoffName) =>
        change(form, cutoffName, cutoffValue)
      )
    );
  }
};

export default connect(null, mapDispatchToProps)(
  TailTypeRadioButtonContainer
);
